export default function TacSidebar({ nav, setNav, stats, collapsed, setCollapsed }) {
  const groups = [
    {
      title: "Core",
      items: [
        ["dashboard", "Dashboard", "▦"]
      ]
    },
    {
      title: "Operations",
      items: [
        ["operations", "Operations Board", "⊞"],
        ["planning", "Operations Planning", "⌖"],
        ["live", "Live Operations", "◉"],
        ["timeline", "Operations Timeline", "☷"],
        ["packets", "Operations Packet", "▤"],
        ["map", "Tactical Map / Staging", "◇"]
      ]
    },
    {
      title: "Readiness",
      items: [
        ["equipment", "Equipment Readiness", "▣"],
        ["roster", "Team Roster", "◎"],
        ["assignments", "Assignments", "⇄"],
        ["training", "Training Tracker", "△"]
      ]
    },
    {
      title: "Command Tools",
      items: [
        ["checklists", "Checklists", "☑"],
        ["threats", "Threat Matrix", "⚠"],
        ["whiteboard", "Whiteboard", "▧"]
      ]
    },
    {
      title: "Reviews",
      items: [
        ["aars", "After-Action Reviews", "☑"]
      ]
    },
    {
      title: "System",
      items: [
        ["admin", "Admin", "⚙"]
      ]
    }
  ];

  return (
    <aside className="sidebar">
      <div className="brand logo-only">
        <img src="/tacops-header.png" alt="TacOps" />
      </div>

      <button className="collapse-btn" onClick={() => setCollapsed(!collapsed)}>
        {collapsed ? "»" : "Collapse «"}
      </button>

      <nav className="grouped-nav">
        {groups.map((group) => (
          <div className="nav-group" key={group.title}>
            <div className="nav-group-title">{group.title}</div>
            {group.items.map(([key, label, icon]) => (
              <button key={key} className={nav === key ? "active" : ""} onClick={() => setNav(key)} title={label}>
                <span className="nav-icon">{icon}</span>
                <span className="nav-label">{label}</span>
              </button>
            ))}
          </div>
        ))}
      </nav>

      <div className="sidebar-status">
        <div>Active Ops <b>{stats.active}</b></div>
        <div>Critical <b>{stats.critical}</b></div>
        <div>Readiness <b>{stats.equipmentPct}%</b></div>
      </div>
    </aside>
  );
}
